var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    fill: "#7D7D7D",
    viewBox: "0 0 10 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.048.8c.209-.21.548-.21.757 0l3.192 3.191L8.188.8a.536.536 0 1 1 .758.758l-3.57 3.57a.536.536 0 0 1-.758 0l-3.57-3.57a.536.536 0 0 1 0-.758",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDown;